module.exports = __webpack_public_path__ + "static/leoburnett-33556020b7f0fa7d438e3131cbef9167.png";